import React, { useEffect, useState } from "react";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import HttpOutlinedIcon from "@mui/icons-material/HttpOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import Card from "react-bootstrap/Card";
import { useDispatch, useSelector } from "react-redux";

import EmptyState from "components/atoms/EmptyState";
import PageContainer from "components/atoms/PageContainer";
import CreatWebService from "components/Leads/CreateWebService";
import ServiceCardSkeleton from "components/Leads/ServiceCardSkeleton";

import { getAllLeadServiceAsync } from "../../redux/slices/leadService/leadService.asyncActions";
import AuthServices from "./AuthServices";

const Services = () => {
    const [businessIdState, setBusinessIdState] = useState("");
    const [webServisPermision, setWebServisPermision] = useState(false);
    const [currentTab, setCurrentTab] = useState(0);
    const language = useSelector((state) => state.languagesState.languages);
    const services = useSelector(
        (state) => state.leadAllLeadServiceState.getAllLeadService.leadService,
    );
    const loading = useSelector(
        (state) => state.leadAllLeadServiceState.getAllLeadService.status,
    );
    const bussiness = useSelector(
        (state) => state.allDashboardDatasState.getAllDashboardDatas.bussiness,
    );

    const dispatch = useDispatch();

    useEffect(() => {
        if (currentTab === 0) {
            dispatch(getAllLeadServiceAsync());
        }
    }, [currentTab]);

    const runDispatchAfterCreate = () => {
        dispatch(getAllLeadServiceAsync());
    };

    useEffect(() => {
        let businessId =
            bussiness &&
            bussiness.length > 0 &&
            bussiness.find((element) => element.selected === true);
        if (businessId.id) {
            setBusinessIdState(businessId.id);
        }
    }, [bussiness]);

    const AddNewServiceBtn = () => {
        setWebServisPermision(true);
    };

    const handleCloseServiceModal = () => {
        setWebServisPermision(false);
    };

    const getDestinationInfo = (destination) => {
        let data = {
            name: "",
            icon: "",
        };
        switch (destination) {
            case 1:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/web-service.png";
                data.name = "Web Service";
                break;
            case 2:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/zoho.png";
                data.name = "Zoho CRM";
                break;
            case 3:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/salesforce.png";
                data.name = "Salesforce";
                break;
            case 4:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/microsoft-dynamics-logo.png";
                data.name = "Microsoft Dynamics";
                break;
            case 5:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/highlevel.png";
                data.name = "High Level";
                break;
            case 6:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/sugar.png";
                data.name = "Sugar CRM";
                break;
            case 7:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/odoo.png";
                data.name = "Odoo";
                break;
            case 8:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/perfex.png";
                data.name = "Perfex";
                break;
            case 9:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/freshsales-crm.png";
                data.name = "Fresh Sales";
                break;
            case 10:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/vtiger-crm.png";
                data.name = "Vtiger";
                break;
            case 11:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/wati.png";
                data.name = "Wati";
                break;
            case 12:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/monday.png";
                data.name = "Monday";
                break;
            case 13:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/hubspot-icon.png";
                data.name = "Hubspot";
                break;
            case 14:
                data.icon =
                    "/assets/images/typeImages/lead/destinations/zendesk-icon.png";
                data.name = "Zendesk";
                break;
        }
        return data;
    };

    const getSourceInfo = (source) => {
        let data = {
            name: "",
            icon: "",
        };
        switch (source) {
            case 1:
                data.icon = "/assets/images/typeImages/lead/sources/fb.png";
                data.name = "Facebook Lead";
                break;
            case 2:
                data.icon = "/assets/images/typeImages/lead/sources/sapi.png";
                data.name = "Source API";
                break;
            case 3:
                data.icon = "/assets/images/typeImages/lead/sources/tt.png";
                data.name = "Tiktok Lead Generation";
                break;
        }
        return data;
    };

    const [webServiceEditModal, setWebServiceEditModal] = useState(false);
    const [webServiceEditId, setWebServiceEditId] = useState(null);
    const [triggerAuthServiceCreate, setTriggerAuthServiceCreate] =
        useState(false);

    const handleOpenServiceModal = (id) => {
        setWebServiceEditId(id);
        setWebServiceEditModal(true);
    };

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    const handleCreateButtonClick = () => {
        if (currentTab === 0) {
            AddNewServiceBtn();
        } else {
            setTriggerAuthServiceCreate(true);
        }
    };

    return (
        <PageContainer
            title={language?.sidebar?.services ?? "Services"}
            subtitle={
                language?.sources?.services_desc ??
                "On this page, you can view services, and create a new one by using the button."
            }
            variant="list"
        >
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Tabs
                    value={currentTab}
                    onChange={handleTabChange}
                    aria-label="services tabs"
                    sx={{
                        "& .Mui-selected": {
                            color: "#ff9800 !important",
                        },
                        "& .MuiTabs-indicator": {
                            backgroundColor: "#ff9800",
                        },
                    }}
                >
                    <Tab
                        label={language?.sidebar?.services ?? "Services"}
                        id="service-tab-0"
                        aria-controls="service-tabpanel-0"
                    />
                    <Tab
                        label={
                            language?.sidebar?.auth_services ?? "Auth Services"
                        }
                        id="service-tab-1"
                        aria-controls="service-tabpanel-1"
                    />
                </Tabs>
                <Button
                    onClick={handleCreateButtonClick}
                    color="primary"
                    variant="contained"
                    sx={{ marginBottom: "8px" }}
                >
                    {currentTab === 0
                        ? (language?.services?.create_service ??
                          "Create Service")
                        : (language?.auth_services?.create_auth_service ??
                          "Create Auth Service")}
                </Button>
            </Box>

            {currentTab === 0 && (
                <Box
                    role="tabpanel"
                    id="service-tabpanel-0"
                    aria-labelledby="service-tab-0"
                >
                    {loading === "loading" && <ServiceCardSkeleton count={6} />}
                    {loading === "success" && !services?.length && (
                        <EmptyState
                            icon={<HttpOutlinedIcon />}
                            title={
                                language?.services?.no_services_yet ??
                                "No services yet"
                            }
                            description={
                                language?.services?.no_services_yet_desc ??
                                "Create a web service to send leads to a custom endpoint."
                            }
                        />
                    )}

                    {loading === "success" && !!services?.length && (
                        <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 12, sm: 12, lg: 4, md: 6 }}
                            className="trackers-area mt-4"
                        >
                            {services?.map((item, index) => (
                                <Grid
                                    size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 6,
                                        lg: 4,
                                    }}
                                >
                                    <Card
                                        className={`dashboard-tree-source-item lead-item service-item dashboard-tree-source-item-${index}`}
                                        style={{
                                            boxShadow: "none",
                                            border: "1px solid #E7E7E7",
                                            borderRadius: "10px",
                                            marginBottom: "20px",
                                            position: "relative",
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            cursor: "default",
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "10px",
                                                right: "10px",
                                                display: "flex",
                                                gap: "5px",
                                                zIndex: 10,
                                            }}
                                        >
                                            <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleOpenServiceModal(
                                                        item?.service_id,
                                                    );
                                                }}
                                                style={{
                                                    backgroundColor: "#f5f5f5",
                                                    padding: "5px",
                                                }}
                                            >
                                                <EditOutlinedIcon fontSize="small" />
                                            </IconButton>
                                        </div>

                                        <CardContent
                                            style={{ padding: "20px" }}
                                            className="d-flex items-center justify-start"
                                        >
                                            <div
                                                style={{
                                                    width: "2rem",
                                                    height: "2rem",
                                                }}
                                                className="mr-3"
                                            >
                                                <img
                                                    src={
                                                        getDestinationInfo(
                                                            item
                                                                ?.destinations[0]
                                                                ?.destination_type_id,
                                                        )?.icon
                                                    }
                                                    alt="Service"
                                                />
                                            </div>
                                            <Typography
                                                sx={{
                                                    fontSize: 18,
                                                    fontWeight: "700",
                                                    fontFamily:
                                                        "Nunito, sans-serif",
                                                    color: "black",
                                                }}
                                            >
                                                {
                                                    getDestinationInfo(
                                                        item?.destinations[0]
                                                            ?.destination_type_id,
                                                    )?.name
                                                }
                                            </Typography>
                                        </CardContent>
                                        <CardContent
                                            style={{
                                                padding: "20px",
                                                paddingTop: "0",
                                            }}
                                            className="d-flex items-center justify-start"
                                        >
                                            <div className="lead-service-info-area">
                                                <span
                                                    style={{
                                                        display: "block",
                                                        fontSize: "14px",
                                                        color: "black",
                                                        fontWeight: "500",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            fontSize: "12px",
                                                            color: "#ABABAB",
                                                            fontWeight: "400",
                                                        }}
                                                    >
                                                        {language?.services
                                                            ?.name ?? "Name"}
                                                    </span>

                                                    <span
                                                        style={{
                                                            display:
                                                                "-webkit-box",
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient:
                                                                "vertical",
                                                            overflow: "hidden",
                                                            textOverflow:
                                                                "ellipsis",
                                                            wordBreak:
                                                                "break-word",
                                                            cursor: "text",
                                                            userSelect: "text",
                                                        }}
                                                    >
                                                        {item?.name}
                                                    </span>
                                                </span>
                                                <span
                                                    style={{
                                                        display: "block",
                                                        fontSize: "14px",
                                                        color: "black",
                                                        fontWeight: "500",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            fontSize: "12px",
                                                            color: "#ABABAB",
                                                            fontWeight: "400",
                                                        }}
                                                    >
                                                        {language?.services
                                                            ?.url ?? "URL"}
                                                    </span>
                                                    <Tooltip
                                                        title={item?.url || ""}
                                                        arrow
                                                        enterDelay={500}
                                                        leaveDelay={200}
                                                    >
                                                        <span
                                                            style={{
                                                                display:
                                                                    "-webkit-box",
                                                                WebkitLineClamp: 2,
                                                                WebkitBoxOrient:
                                                                    "vertical",
                                                                overflow:
                                                                    "hidden",
                                                                textOverflow:
                                                                    "ellipsis",
                                                                wordBreak:
                                                                    "break-all",
                                                                cursor: "text",
                                                                userSelect:
                                                                    "text",
                                                            }}
                                                        >
                                                            {item?.url}
                                                        </span>
                                                    </Tooltip>
                                                </span>
                                                <span
                                                    style={{
                                                        display: "block",
                                                        fontSize: "14px",
                                                        color: "black",
                                                        fontWeight: "500",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            display: "block",
                                                            fontSize: "12px",
                                                            color: "#ABABAB",
                                                            fontWeight: "400",
                                                        }}
                                                    >
                                                        {language?.services
                                                            ?.method ??
                                                            "Method"}
                                                    </span>

                                                    <span
                                                        style={{
                                                            display:
                                                                "-webkit-box",
                                                            WebkitLineClamp: 1,
                                                            WebkitBoxOrient:
                                                                "vertical",
                                                            overflow: "hidden",
                                                            textOverflow:
                                                                "ellipsis",
                                                            wordBreak:
                                                                "break-word",
                                                            cursor: "text",
                                                            userSelect: "text",
                                                        }}
                                                    >
                                                        {item?.method}
                                                    </span>
                                                </span>
                                            </div>
                                        </CardContent>
                                        {item?.has_connections ? (
                                            <CardContent
                                                style={{
                                                    padding: "20px",
                                                    paddingTop: "0",
                                                }}
                                                className="d-flex items-center justify-start"
                                            >
                                                <div className="in-use-area">
                                                    {language?.destinations
                                                        ?.in_use ?? "In Use"}
                                                </div>
                                            </CardContent>
                                        ) : (
                                            <CardContent
                                                style={{
                                                    padding: "20px",
                                                    paddingTop: "0",
                                                }}
                                                className="d-flex items-center justify-start"
                                            >
                                                <div className="not-in-use-area">
                                                    {language?.destinations
                                                        ?.ready_for_assignment ??
                                                        "Ready for Assignment"}
                                                </div>
                                            </CardContent>
                                        )}
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    )}

                    {webServisPermision && (
                        <>
                            <CreatWebService
                                businessIdState={businessIdState}
                                destinationSelections="Web Service"
                                destinationType="http"
                                handleCloseServiceModal={
                                    handleCloseServiceModal
                                }
                                runDispatchAfterCreate={runDispatchAfterCreate}
                            />
                        </>
                    )}

                    {webServiceEditModal && (
                        <>
                            <CreatWebService
                                businessIdState={businessIdState}
                                destinationSelections="Web Service"
                                destinationType={"http"}
                                handleCloseServiceModal={() => {
                                    setWebServiceEditModal(false);
                                    setWebServiceEditId(null);
                                }}
                                runDispatchAfterCreate={runDispatchAfterCreate}
                                serviceId={webServiceEditId}
                            />
                        </>
                    )}
                </Box>
            )}

            {currentTab === 1 && (
                <Box
                    role="tabpanel"
                    id="service-tabpanel-1"
                    aria-labelledby="service-tab-1"
                >
                    <AuthServices
                        triggerCreate={triggerAuthServiceCreate}
                        onCreateTriggered={() =>
                            setTriggerAuthServiceCreate(false)
                        }
                    />
                </Box>
            )}
        </PageContainer>
    );
};

export default Services;
